import EditButton from './EditButton';
import EditButtonContainer from './EditButton.container';
export default EditButtonContainer(EditButton);
